function parseGroupOrderDetails(options) {
  const { guestId, merchantId, order } = options;
  const details = {
    allMembers: [],
    host: {},
    isLocked: false,
    otherMembers: [],
    you: {
      orderItemCount: 0,
      orderItems: []
    }
  };

  if (!order.groupOrder || !order.groupOrder.token) {
    // NOTE: Checking !order.groupOrder.token is important to make sure we're not re-parsing the default object
    return details;
  }

  details.isLocked = order.groupOrder.isLocked || false;
  details.link = `${window.location.origin}/${merchantId}/order/join-group/${order.groupOrder.token}`;
  details.name = order.groupOrder.name;
  details.token = order.groupOrder.token;

  const members = order.groupOrder.members.map((m) => {
    const displayName = m.displayName.trim();
    let displayNameInitials = '';
    const displayNameSegments = displayName.split(' ');
    const orderItems = [];
    let orderItemCount = 0;
    let subtotal = 0;

    const [firstInitial] = displayNameSegments[0];
    displayNameInitials += firstInitial;

    if (displayNameSegments.length > 1) {
      const [lastInitial] = displayNameSegments[displayNameSegments.length - 1];
      displayNameInitials += lastInitial;
    }

    m.orderItemIds.forEach((id) => {
      const orderItem = order.orderItems.find(item => item.orderItemId === id);

      if (orderItem) {
        subtotal += (orderItem.priceTotal * orderItem.quantity);
        orderItemCount += orderItem.quantity;
        orderItems.push(orderItem);
      }
    });

    return {
      displayName,
      displayNameInitials,
      guestId: m.guestId,
      isHost: m.isHost,
      orderItemCount,
      orderItems,
      phoneNumber: m.phoneNumber,
      subtotal,
      ticketNumber: m.ticketNumber
    };
  });

  details.allMembers = members;

  details.host = members.find(member => member.isHost);

  details.otherMembers = members.filter((m) => {
    if (guestId) {
      return m.guestId !== guestId;
    }

    return false;
  });

  details.you = members.find(m => guestId && m.guestId === guestId);

  return details;
}



export default parseGroupOrderDetails;
